import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import FeatureUtils from '@appblocks/codegeneration/FeatureUtils';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    AppBlockPort,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeArgument from '@appblocks/codegeneration/Nodes/NodeArgument';

export default class BaseNode extends BaseFeature {
    inputs: AppBlockPort[];

    outputs: AppBlockPort[];

    isAsync: boolean;

    constructor() {
        super();
        this.name = 'basenode';
        this.id = 'basenode';
        // default icon
        this.icon = 'FaRegCaretSquareRight';
        this.isAsync = false; // this is used to check if the node is async
        // when block is async, outputs will only be traversed once
        this.inputs = [];
        this.outputs = [
            {
                name: 'Done',
                portId: 'done',
                params: [],
            },
        ];

        const settings = [
            {
                id: 'DISPLAY_NAME',
                name: 'Label',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
            {
                id: 'FEATURE',
                name: 'Attached Feature',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
            {
                id: 'X',
                name: 'X',
                settingType: SettingType.NUMBER,
                required: true,
                default: 0,
            },
            {
                id: 'Y',
                name: 'Y',
                settingType: SettingType.NUMBER,
                required: true,
                default: 0,
            },
            {
                id: 'INPUTS',
                name: 'Inputs',
                settingType: SettingType.ARRAY,
                required: true,
                readonly: true,
                refId: 'node_port',
                default: [] as NodePort[],
            },
            {
                id: 'OUTPUTS',
                name: 'Outputs',
                settingType: SettingType.ARRAY,
                required: true,
                readonly: true,
                refId: 'node_port',
                default: [] as NodePort[],
            },
            {
                id: 'GROUP',
                name: 'Group',
                settingType: SettingType.HIDDEN,
                required: false,
                default: '',
            },
            {
                id: 'ARGUMENTS',
                name: 'Arguments',
                settingType: SettingType.ARRAY,
                // readonly: true,
                refId: 'node_argument',
                default: [] as NodeArgument[],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    initSettings(project: ProjectConfiguration) {
        super.initSettings(project);
        // const INPUTS = this.getSettingValue('INPUTS');
    }

    validate(): ValidationMessage[] {
        const errors: ValidationMessage[] = [];
        const project: ProjectConfiguration = this.project;
        const INPUTS = this.getInputs();
        const ARGUMENTS = this.getSettingValue('ARGUMENTS');
        for (let i = 0; i < INPUTS.length; i += 1) {
            const input = INPUTS[i];
            const params = input.params;
            for (let k = 0; k < params.length; k++) {
                const param = params[k];
                let found = false;
                for (let j = 0; j < ARGUMENTS.length; j += 1) {
                    const arg = ARGUMENTS[j];
                    if (arg.getSettingValue('TARGETPARAM') === param.name) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    const arg = new NodeArgument();
                    arg.initSettings(project);
                    arg.setSettingValue('TARGETPARAM', param.name);
                    arg.setSettingValue('ARGVALUE', param.default);
                    errors.push({
                        messageType: ValidationMessageType.ADD,
                        message: '',
                        featureId: this.getID(),
                        settingId: 'ARGUMENTS',
                        data: FeatureUtils.toJson(arg),
                    });
                }
            }
        }
        return errors.concat(super.validate());
    }

    getName(): string {
        return this.name;
    }

    getState(settingId: string): SettingState {
        switch (settingId) {
            case 'DISPLAY_NAME':
            case 'FEATURE':
            case 'X':
            case 'Y':
            case 'INPUTS':
            case 'OUTPUTS':
            case 'ARGUMENTS':
                return SettingState.HIDDEN;
            default:
                return SettingState.ENABLED;
        }
    }

    getPort(portId: string): AppBlockPort | undefined {
        const ports = this.getInputs().concat(this.getOutputs());
        for (let i = 0; i < ports.length; i += 1) {
            if (ports[i].portId === portId) {
                return ports[i];
            }
        }
        return undefined;
    }

    getInputs(): AppBlockPort[] {
        // return this.getSettingValue('INPUTS');
        return this.inputs;
    }

    getOutputs(): AppBlockPort[] {
        // return this.getSettingValue('OUTPUTS');
        return this.outputs;
    }

    getLabel(): string {
        return this.name;
    }

    getDocURL(): string {
        return `${process.env.HOME_URL}/docs/blocks/${this.id}`;
    }
}
